export const color = [
  "white",
  "Black",
  "Red",
  "marun",
  "Being",
  "Pink",
  "Green",
  "Yellow",
];

export const filters = [
  // Akhil comments - Color filter hidden as per requirement
  // {
  //   id: "color",
  //   name: "Color",
  //   options: [
  //     { value: "white", label: "White" },
  //     { value: "beige", label: "Beige" },
  //     { value: "blue", label: "Blue" },
  //     { value: "brown", label: "Brown" },
  //     { value: "green", label: "Green" },
  //     { value: "purple", label: "Purple" },
  //     {value:"yellow",label:"Yellow"}
  //   ],
  // },

  {
    id: "size",
    name: "Size",
    options: [
      { value: "Small Box", label: "Small Box" },
      { value: "Large Box", label: "Large Box" },
      { value: "XL Box", label: "XL Box" },
      { value: "Bulk Box", label: "Bulk Box" },
    ],
  },

];

export const singleFilter = [
  // Akhil comments - Price filter moved to custom component with From/To inputs
  // {
  //   id: "price",
  //   name: "Price",
  //   options: [
  //     { value: "1-5", label: "$1 To $5" },
  //     { value: "5-10", label: "$5 To $10" },
  //     { value: "10-20", label: "$10 To $20" },
  //     { value: "20-50", label: "$20 To $50" },
  //     { value: "50-100", label: "$50 To $100" },
  //   ],
  // },
  // Akhil comments - Discount Range filter hidden as per requirement
  // {
  //   id: "disccout",
  //   name: "Disccount Range",
  //   options: [
  //     {
  //       value: "10",
  //       label: "10% And Above",
  //     },
  //     { value: "20", label: "20% And Above" },
  //     { value: "30", label: "30% And Above" },
  //     { value: "40", label: "40% And Above" },
  //     { value: "50", label: "50% And Above" },
  //     { value: "60", label: "60% And Above" },
  //     { value: "70", label: "70% And Above" },
  //     { value: "80", label: "80% And Above" },
  //   ],
  // },
  // Akhil comments - Availability filter hidden as per requirement
  // {
  //   id: "stock",
  //   name: "Availability",
  //   options: [
  //     { value: "in_stock", label: "In Stock" },
  //     { value: "out_of_stock", label: "Out Of Stock" },
  //   ],
  // },
]

export const sortOptions = [

  { name: "Price: Low to High", query: "price_low", current: false },
  { name: "Price: High to Low", query: "price_high", current: false },
];

